import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import { getModel, getViewer, utils as macheteUtils } from 'src/machete-redux';
import constants from 'src/constants';
import WidthAndHeight from '../WidthAndHeight';
import { Container, Details, Name, Area } from './styled';
import featureFlags from 'src/featureFlags';

const { UNITS } = constants.measure;
const { OUTLINE_OPTS, FOCUS_OPTS } = constants.machete;

export default class OpeningItem extends PureComponent {
  propTypes = {
    name: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    uuid: PropTypes.string.isRequired,
  };

  @autobind
  outlineAndFocusOnAnnotation() {
    const {
      addOutlineToElement,
      removeOutlineFromElement,
      addTextToAnnotation,
      removeTextFromElement,
    } = macheteUtils;

    const elements = featureFlags.shouldUseWindowConsistentMeasurements()
      ? getModel().elements
      : getModel().annotations;

    elements.forEach((element) => {
      if (element.uuid === this.props.uuid) {
        getViewer().focus(element, FOCUS_OPTS.getDefault());
        addOutlineToElement(element, OUTLINE_OPTS.getFocused());
        addTextToAnnotation(element);
      } else {
        removeOutlineFromElement(element);
        removeTextFromElement(element);
      }
    });
  }

  render() {
    const { name, width, height } = this.props;

    return (
      <Container onClick={this.outlineAndFocusOnAnnotation}>
        <Details>
          <Name data-selenium="openingItemNameText">{name}</Name>
          <Area>
            <WidthAndHeight
              width={width}
              height={height}
              unit={UNITS.inches.symbol}
            />
          </Area>
        </Details>
      </Container>
    );
  }
}
